<template>
  <div class="relative h-full w-full">
    <span
      v-for="flake in flakes"
      :key="flake.id"
      class="snowflake"
      :style="flake.style"
    >
      ❄️
    </span>
    <span
      v-for="flake in flakesMd"
      :key="flake.id"
      class="snowflake snowflake-md"
      :style="flake.style"
    >
      ❄️
    </span>
  </div>
</template>

<script>
export default {
  name: 'SnowFlakesComponent',
  data() {
    return {
      flakes: [],
      flakesMd: []
    }
  },
  mounted() {
    this.flakes = Array.from({ length: 250 }, (_, i) => {
      const duration = (Math.random() * 3 + 3).toFixed(2) + 's'
      const delay = (Math.random() * -5).toFixed(2) + 's'
      const left = Math.random() * 120 - 20 + 'vw'
      const blur = Math.floor(Math.random() * 2) + 'px'

      return {
        id: i,
        style: {
          left,
          filter: `blur(${blur})`,
          animation: `${duration} flickr ${delay} infinite,
                      ${(Math.random() * 50 + 10) / 5}s fall ${(Math.random() * -20) / 10}s infinite`
        }
      }
    })
    this.flakesMd = Array.from({ length: 50 }, (_, i) => {
      const duration = (Math.random() * 3 + 3).toFixed(2) + 's'
      const delay = (Math.random() * -5).toFixed(2) + 's'
      const left = Math.random() * 120 - 20 + 'vw'
      const blur = Math.floor(Math.random() * 2) + 'px'

      return {
        id: i,
        style: {
          left,
          filter: `blur(${blur})`,
          animation: `${duration} flickr ${delay} infinite,
                      ${(Math.random() * 50 + 10) / 5}s fall ${(Math.random() * -20) / 10}s infinite`
        }
      }
    })
  }
}
</script>

<style>
.snowflake {
  position: absolute;
  top: -2vh;
  font-size: 10px;
  opacity: 0.8;
  user-select: none;
  pointer-events: none;
}

.snowflake-md {
  font-size: 16px;
}

@keyframes flickr {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
}

@keyframes fall {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  100% {
    transform: translate(20vw, 110vh) rotate(360deg);
  }
}
</style>
